import { get, post } from '@/utils/request'

// ==================== 资料文件夹相关接口 ====================
const FOLDER_BASE_URL = '/cmp-doc/data-project-folder';

// 添加文件夹
export const addFolder = (params: any, requestId?: string): Promise<number> => {
  return post(`${FOLDER_BASE_URL}/add${requestId ? `?requestId=${requestId}` : ''}`, params, {}, 'document')
}

// 修改文件夹
export const updateFolder = (params: any, requestId?: string): Promise<boolean> => {
  return post(`${FOLDER_BASE_URL}/modify${requestId ? `?requestId=${requestId}` : ''}`, params, {}, 'document')
}

// 删除文件夹
export const deleteFolder = (data: any, requestId: string): Promise<void> => {
  return post(`${FOLDER_BASE_URL}/remove?requestId=${requestId}`, data, {}, 'document')
}

// 查询文件夹列表
export const getFolderList = (params: any): Promise<any[]> => {
  return post(`${FOLDER_BASE_URL}/list`, params, {}, 'document')
}

// @Operation(summary = "根据条件查询文档和文件夹列表", description = "根据条件查询文档和文件夹列表，返回结果根据文档名的拼音顺序排序,文档和文件夹不能混合排序")
export const getFolderAndDocList = (params: any): Promise<any[]> => {
  return post(`${FOLDER_BASE_URL}/list-doc-folder-view`, params, {}, 'document')
}
